// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TabNavigation_tabs__KocXk","selectedTab":"TabNavigation_selectedTab__uIGeg","tooltip":"TabNavigation_tooltip__1rLB6"};